import React from "react";
import PropTypes from "prop-types";
import { DialogActions, Button } from "@mui/material";

const AddCancelDialogButtons = ({ onCancel, onSubmit, loading, cancelLabel, submitLabel }) => {
  if (loading) return null;

  return (
    <DialogActions>
      <Button onClick={onCancel} color="secondary">
        {cancelLabel}
      </Button>
      <Button
        onClick={onSubmit}
        color="primary"
        sx={{
          "&:hover": { backgroundColor: "blue", color: "#fff" },
        }}
      >
        {submitLabel}
      </Button>
    </DialogActions>
  );
};

AddCancelDialogButtons.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  cancelLabel: PropTypes.string,
  submitLabel: PropTypes.string,
};

AddCancelDialogButtons.defaultProps = {
  loading: false,
  cancelLabel: "Cancel",
  submitLabel: "Submit",
};

export default AddCancelDialogButtons;
